// The HERO slot of a home widget (HOME_WIDGETS_SPEC.md §2): one display
// numeral with its unit as a grey word on the same line — "34 contacts",
// "USD 12.4K", "7 out".
//
//   HomeWidgetHero: {
//     Value: { text: (el, s) => el.call('crmContactCount', s.root) },
//     Unit: { text: '{{ apps.widget.crmRecent.unit | polyglot }}' },
//     unitFirst: true    // money: the ISO code word leads ("USD 12.4K")
//   }
//
// The numeral is the sans face at weight 300, tabular, tracked −0.03em, `E` at
// S/M and `F` at L/XL; the unit (and the optional trailing `Tail` word) is
// `A` 400 `inactive`. Text stays neutral — the widget hue lives on the plate
// and the visual only (spec §3).
//
// QUALITY LAW (HOME_AMBIENT_SKIN_SPEC §3): the hero is PRIMARY text and never
// truncates — the numeral is compact by contract (the body's formatter:
// 12.4K, 86.9M) and the unit words wrap under it instead of an ellipsis.
//
// LOADING — `Value.text` (a string, or an `(el, s)` factory returning one)
// null/undefined means "not read yet": a skeleton bar
// one numeral-line tall stands in and the unit words hide, so the row keeps
// the height the numeral will have (zero shift when the number lands). An
// empty string is a real answer, not a load state.
export const HomeWidgetHero = {
  class: 'widget-hero',
  gridArea: 'hero',
  display: 'flex',
  flexFlow: 'row wrap',
  alignItems: 'baseline',
  columnGap: 'Y',
  minWidth: '0',
  unitFirst: false,

  Value: {
    tag: 'span',
    fontSize: 'E',
    fontWeight: '300',
    lineHeight: '1',
    letterSpacing: '-0.03em',
    fontVariantNumeric: 'tabular-nums',
    color: 'title',
    whiteSpace: 'nowrap',
    ':is([data-widget-size="l"]) &': { fontSize: 'F' },
    ':is([data-widget-size="xl"]) &': { fontSize: 'F' }
  },

  Unit: {
    tag: 'span',
    order: (el) => (el.parent.unitFirst ? '-1' : '0'),
    fontSize: 'A',
    fontWeight: '400',
    lineHeight: '1.3',
    color: 'inactive',
    overflowWrap: 'anywhere',
    minWidth: '0',
    hide: (el) => el.call('homeSlotText', el.parent.Value) == null
  },

  Tail: {
    tag: 'span',
    fontSize: 'A',
    fontWeight: '400',
    lineHeight: '1.3',
    color: 'inactive',
    overflowWrap: 'anywhere',
    hide: (el) => !el.call('homeSlotText', el) || el.call('homeSlotText', el.parent.Value) == null
  },

  Skeleton: {
    fontSize: 'E',
    width: '2.4em',
    height: '1em',
    ':is([data-widget-size="l"]) &': { fontSize: 'F' },
    ':is([data-widget-size="xl"]) &': { fontSize: 'F' },
    hide: (el) => el.call('homeSlotText', el.parent.Value) != null
  }
}
